import { render, staticRenderFns } from "./FaqCard.vue?vue&type=template&id=3b1119f4"
import script from "./FaqCard.vue?vue&type=script&lang=js"
export * from "./FaqCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports